import { render, staticRenderFns } from "./Contributions.vue?vue&type=template&id=63a8c107&scoped=true&"
import script from "./Contributions.vue?vue&type=script&lang=js&"
export * from "./Contributions.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/views/_contributions.scss?vue&type=style&index=0&id=63a8c107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8c107",
  null
  
)

export default component.exports